import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDrawer } from '@angular/material/sidenav';
import { MatIconRegistry } from '@angular/material/icon';
import { NavigationService } from './service/navigation.service';
import { DateFormattingUtils } from './service/date-formatting-utils';
import { Features, FeaturesI18N } from 'controls';
import { Activity } from './model/activity';
import { UserModelI18N } from 'src/webid/4.0/model/i18n';
import { UserModelDict } from 'src/webid/4.0/model/dict';
import { IBirthplaceDictionary } from 'src/webid/4.0/model/dictionaries/couchdb.birthplace.dictionary';
import { UserModelVisibilityMobile } from 'src/webid/4.0/model/visibility';
import { UserModelValidationMobile } from 'src/webid/4.0/model/validation';
import { RequestFeatures } from 'src/webid/4.0/model/features';
import { RequestFeaturesV2 } from 'src/webid/4.0/model/features2';
import { ApplicationUpdateService } from './service/application-update.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    @ViewChild('drawer') drawer: MatDrawer;

    public activity: Activity;

    constructor(
        private navigationService: NavigationService,
        private dictionary: IBirthplaceDictionary,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private updateService: ApplicationUpdateService,
    ) {
        this.activity = this.navigationService.activity;
    }

    ngOnInit(): void {
        new UserModelI18N();
        new UserModelVisibilityMobile();
        new UserModelValidationMobile();
        new UserModelDict(this.dictionary);
        FeaturesI18N.setLocale('ru-RU');
        FeaturesI18N.addString('ru-RU', 'command.request.abandon', 'Черновик');
        FeaturesI18N.addString('ru-RU', 'STATUS.RequestFeatures.DATA_ENTERED', 'Черновик');
        FeaturesI18N.addString('ru-RU', 'STATUS.RequestFeaturesV2.DATA_ENTERED', 'Черновик');
        Features.processDeferredMetadata([new RequestFeatures(), new RequestFeaturesV2()]);
        DateFormattingUtils.setupMomentParser();
        this.addSvgIcon('edit-24px');
        this.addSvgIcon('qr_code');
        this.updateService.updateDetection();
    }

    isSideMenuVisible(): boolean {
        //return this.navigationService.isCurrentRouteHome();
        return false;
    }

    isBackButtonVisible(): boolean {
        return !this.navigationService.isCurrentRouteHome();
    }

    openSideMenu(): void {
        this.drawer.open();
    }

    closeSideMenu(): void {
        this.drawer.close();
    }

    navigateBack(): void {
        this.navigationService.navigateBack();
    }

    private addSvgIcon(name: string) {
        let url = `./assets/images/${name}.svg`;
        let secured = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
        this.matIconRegistry.addSvgIcon(name, secured);
    }
}
